import { useState } from "react";
import "./Navbar.css";

function Navbar({
  navLinks = [],
}) {
  const [menuOpen, setMenuOpen] = useState(false);

  function toggleNavMenu() {
    setMenuOpen(prev => !prev);
  }

  return (
    <nav id="nav" className={`whiteText ${menuOpen ? "active" : ""}`}>
      <div className="wrapper">
        <a className="logo" href="/">

        </a>

        <button
          className="hambugerButton"
          onClick={toggleNavMenu}
          aria-label="Toggle menu"
        >
          <div className="icon">
            <span></span>
            <span></span>
          </div>
        </button>

        {navLinks.map((link, index) => (
          <a key={index} href={link.href}>
            {link.label}
          </a>
        ))}
      </div>

      <div className="menu">
        {navLinks.map((link, index) => (
          <a key={index} href={link.href} onClick={toggleNavMenu}>
            {link.label}
          </a>
        ))}
      </div>
    </nav>
  );
}

export default Navbar;